module.exports = __webpack_public_path__ + "img/bgr-checkout.55c2c8a5.png";